// extracted by mini-css-extract-plugin
module.exports = {"label":"FileInput_label__1Otw6","fileContainer":"FileInput_fileContainer__EEGxX","fileName":"FileInput_fileName__4T15X"};